import ApplicationsListItem from "./ApplicationsListItem";

export default ApplicationsListItem;
